import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  overwriteVersionRequest,
  overwriteVersionSuccess,
  overwriteVersionFailure,
} from '../reducers/savedVersions';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/version/`;

function* versionAxios() {
  const state = yield select(fullState => fullState);
  const { token } = state.loginReducer;
  const { selectedUserVersion: versionId } = state.userProgramsFullReducer;
  const { pathToSaveVersion: pathToVersion } = state.savedVersionsReducer;
console.log('JOURNAL PATH1',state.savedVersionsReducer )
  const response = yield call(() =>
    axios({
      method: 'put',
      url: `${API}${versionId}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      data: {
        pathToVersion,
      },
    }),
  );
  console.log('JOURNAL PATH2',response )
  return response;
}

function* workerVersionSaga() {
  try {
    const response = yield call(versionAxios);
    if (response.status === 200) {
      yield put(overwriteVersionSuccess(response.data.data));
    }
    if (response.status === 400) {
      yield put(overwriteVersionFailure('Content does not exist'));
    }
  } catch (error) {
    yield put(overwriteVersionFailure(error));
  }
}

export function* watcherVersionSaga() {
  yield takeLatest(overwriteVersionRequest().type, workerVersionSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/put_version.js